import { render, staticRenderFns } from "./LectureDetail.vue?vue&type=template&id=39487722&"
import script from "./LectureDetail.vue?vue&type=script&lang=js&"
export * from "./LectureDetail.vue?vue&type=script&lang=js&"
import style0 from "./LectureDetail.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports